import { useTranslation } from 'react-i18next';
import { Chip } from '@/components/Chip';
import { I18nNamespace } from '@/lib/i18n-namespaces';

interface RoleBadgeProps {
    role: string;
    variant?: 'default' | 'positive';
    onRemove?: () => void;
    onClick?: () => void;
}

export function RoleBadge({
    role,
    variant = 'default',
    onRemove,
    onClick,
}: RoleBadgeProps) {
    const { t } = useTranslation(I18nNamespace.SETTINGS);
    const label = t(`members.roles.${role}`, { defaultValue: role });

    return (
        <Chip
            value={label}
            variant={variant}
            onRemove={onRemove}
            onClick={onClick}
        />
    );
}
